import { buildSvgPath } from "@/scripts/common/svg-path";

document.addEventListener("DOMContentLoaded", () => {
  const pathContainer = document.querySelector(".element-locationteam .path-container");

  const getPathPoints = () => {
    const title = pathContainer.querySelector(".element-title");
    const titleRect = title.getBoundingClientRect();
    const teamGroups = pathContainer.querySelector(".team-groups");
    const teamGroupsRect = teamGroups.getBoundingClientRect();

    const points = [];

    if (!window.matchMedia("(min-width: 768px)").matches) {
      return points;
    }

    points.push({ x: titleRect.x + 24, y: titleRect.y + titleRect.height + 16 });
    points.push({ x: titleRect.x + 24, y: teamGroupsRect.y + teamGroupsRect.height / 2.4 });
    points.push({
      x: titleRect.x + (teamGroupsRect.x - titleRect.x),
      y: teamGroupsRect.y + teamGroupsRect.height / 2.4,
    });

    return points;
  };

  const handleSvgPath = () => {
    const pathPoints = getPathPoints();

    buildSvgPath(pathContainer, pathPoints, { gradientId: "page-line-gradient-faded" });
  };

  const resizeObserver = new ResizeObserver(() => requestAnimationFrame(handleSvgPath));
  resizeObserver.observe(document.body);
});
